import User from './System/User'
import UserAcess from './System/UserAcess'
import FilesRegistered from './System/FilesRegistered'
import Contacts from './General/Contacts'
import Budgets from './General/Budgets'
import Cards from './Chart/Cards'

export default {
  System: {
    User,
    UserAcess,
    FilesRegistered
  },
  General: {
    Contacts,
    Budgets
  },
  Chart: {
    Cards
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/index.js